import { render, staticRenderFns } from "./edit-ceping2.vue?vue&type=template&id=4f9b5ce2&scoped=true&"
import script from "./edit-ceping2.vue?vue&type=script&lang=ts&"
export * from "./edit-ceping2.vue?vue&type=script&lang=ts&"
import style0 from "./edit-ceping2.vue?vue&type=style&index=0&id=4f9b5ce2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b5ce2",
  null
  
)

export default component.exports